export default __webpack_public_path__ + "locales/fi/SMTPSettings.json?hash=9aaa6ab2ffc90f0ad438f969e90c063b";